const primaryColor = '#3a0031';

const primaryLightColor = `${primaryColor}33`;

export const customSelectStyles = {
  control: (provided, state) => ({
    ...provided,
    borderColor: state.isFocused ? primaryColor : provided.borderColor,
    boxShadow: state.isFocused ? `0 0 0 1px ${primaryColor}` : provided.boxShadow,
    '&:hover': {
      borderColor: state.isFocused ? primaryColor : provided.borderColor,
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? primaryColor : state.isFocused ? primaryLightColor : 'transparent',
    color: state.isSelected ? '#fff' : provided.color,
    '&:active': {
      backgroundColor: state.isSelected ? primaryColor : primaryLightColor,
    },
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? primaryColor : provided.color,
  }),
  indicatorSeparator: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? primaryColor : provided.backgroundColor,
  }),
  menuList: (provided) => ({
    ...provided,
  }),
};